import { viemChains } from '@vaultsfyi/common/constants'
import { normalize } from 'viem/ens'
import type { Config } from 'wagmi'
import { getEnsAddress } from 'wagmi/actions'

export async function getEnsOrAddress(value: string, wagmiConfig: Config) {
  if (value.endsWith('.eth')) {
    try {
      const address = await getEnsAddress(wagmiConfig, { name: normalize(value), chainId: viemChains['mainnet'].id })
      if (!address) {
        throw new Error('ENS name not found')
      }
      return { address, method: 'ENS' }
    } catch {
      throw new Error('ENS name not found')
    }
  }

  return { address: value, method: 'Address' }
}
